import { Dropdown } from 'antd';

import { DeleteDocIcon, EditDocIcon } from '../../assets';
import DownloadOutlined from '../../assets/docchat/DownloadOutlined';
import ThreeDotOutlined from '../../assets/docchat/ThreeDotOutlined';
import { stopPropagationFunc } from '../../utils/functions';

const SavedComparisonsSidebarItem = ({
  data,
  uuid,
  onComparisonClick,
  formatIndianLongDate,
  handleModal,
}) => {
  const items = [
    {
      key: 'edit',
      label: 'Rename comparison',
      icon: <EditDocIcon />,
      onClick: (e) => {
        stopPropagationFunc(e);
        handleModal('edit', data);
      },
    },
    // {
    //   key: 'share',
    //   label: 'Share',
    //   icon: <ShareIcon3 size={14} />,
    //   onClick: (e) => {
    //     // stopPropagationFunc(e);
    //     // handleModal('edit', record);
    //   },
    // },
    {
      key: 'export',
      label: 'Export',
      icon: <DownloadOutlined />,
      onClick: (e) => {
        stopPropagationFunc(e);
        handleModal('export', data);
      },
    },
    {
      key: 'delete',
      label: 'Delete',
      icon: <DeleteDocIcon />,
      onClick: (e) => {
        stopPropagationFunc(e);
        handleModal('delete', data);
      },
    },
  ];

  return (
    <li
      className={data?.id === uuid ? 'active' : ''}
      id={data?.id}
      onClick={() => onComparisonClick(data)}
    >
      <div>
        <div className='fs-14 ellipsis' title={data?.title}>
          {data?.title}
        </div>
        <div className='fs-10 color-n8'>{formatIndianLongDate(data?.modified)}</div>
      </div>
      <Dropdown
        menu={{ items }}
        trigger={['click']}
        overlayClassName='file-menu-dropdown'
        destroyOnHidden
      >
        <button
          className='action-btn'
          onClick={(e) => e.stopPropagation()}
          style={{ marginTop: '5px' }}
        >
          <ThreeDotOutlined />
        </button>
      </Dropdown>
    </li>
  );
};

export default SavedComparisonsSidebarItem;
